import Input from "sap/m/Input";
import { ValueState } from "sap/ui/core/library";
import SimpleForm from "sap/ui/layout/form/SimpleForm";
import PropertyBinding from "sap/ui/model/PropertyBinding";
import SimpleType from "sap/ui/model/SimpleType";

export class FormValidator {
  public static validate(oForm: SimpleForm) {
    const aControls = oForm.getContent();
    let bValidationError = false;

    for (let i = 0; i < aControls.length; i++) {
      let sValueState = ValueState.None;
      const ctrl = aControls[i];
      const valueBinding = ctrl.getBinding("value") as PropertyBinding;
      if (valueBinding) {
        const bindingType = valueBinding.getType() as SimpleType;
        try {
          bindingType.validateValue((<Input>ctrl).getValue() ?? "");
        } catch (oException: any) {
          sValueState = ValueState.Error;
          bValidationError = true;
        }
        (<Input>ctrl).setValueState(sValueState);
      }
    }

    return bValidationError;
  }
}
